import type { Author } from '~/interfaces/author';
import type { Publication } from '~/interfaces/publication';

import getCanonicalUrl from '../getCanonicalUrl';
import getPersonSchema from '../getPersonSchema';

export interface AuthorPageMeta {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  structuredData: Record<string, unknown>;
}

const getAuthorPageMeta = (author: Author, publication?: Pick<Publication, 'name' | 'url'>): AuthorPageMeta => {
  const baseUrl = publication?.url ? publication.url.replace(/\/?$/, '/') : '';
  const authorUrl = baseUrl ? `${baseUrl}authors/${author.slug || author.id}` : '';
  const canonicalAuthorUrl = getCanonicalUrl(authorUrl);

  return {
    title: author.name ?? undefined,
    description: author.bio || undefined,
    canonicalUrl: authorUrl || undefined,
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'ProfilePage',
      url: canonicalAuthorUrl,
      mainEntity: getPersonSchema(author, { url: canonicalAuthorUrl, publication }),
    },
  };
};

export default getAuthorPageMeta;
